import Vue from 'vue'

const actions = {
  checkBlocked ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/blocked.json').then((response) => {
        commit('SET_BLOCKED', { blocked: response.data })

        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}

export default actions
